var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.country
    ? _c(_vm.marketComponent, {
        ref: "market-component",
        tag: "component",
        staticClass: "market-component",
        attrs: {
          "suggested-addresses-value": _vm.suggestedAddresses,
          lang: _vm.lang,
          "include-email": _vm.includeEmail,
          "email-required": _vm.emailRequired,
        },
        on: {
          blur: _vm.onBlur,
          input: _vm.onInput,
          "new-address-in-form": _vm.onNewAddressInForm,
          "suggested-addresses-updated": _vm.onSuggestedAddressesUpdated,
        },
        model: {
          value: _vm.address,
          callback: function ($$v) {
            _vm.address = $$v
          },
          expression: "address",
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }